<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 13:52:03
 * @LastEditTime: 2020-11-19 16:00:04
 * @LastEditors: wutt
 -->
 

<!--  -->
<template>
  <div style="height:calc(100% - 30px)">
    <el-container style="height:100%">
      <el-main style="height:calc(100% - 55px)">
        <ul>
          <li
            class="liItem"
            v-for="item in pois"
            :key="item.id"
            @click="_poiItemClick(item)"
            @mouseover="_poiItemMouseOver(item)"
            @mouseout="_poiItemMouseOut(item)"
          >
            <div>
              <img :src="item.image" class="img_poiDetail">
            </div>

            <div class="div_POIDetail">
              <span class="poi_item_name"> {{item.name}}</span>
              <p
                v-show="item.phone"
                class="poi_item_info"
              >{{"电话:" + item.phone}}</p>
              <p
                v-show="item.address"
                class="poi_item_info"
              >{{"地址:" + item.address}}</p>
            </div>

          </li>
        </ul>
      </el-main>

      <el-footer
        v-show="ucSetting.pagination.count>0"
      >
        <el-pagination
          @current-change="_paginationCurrentChange"
          :page-size="ucSetting.pagination.pageSize"
          :current-page.sync="ucSetting.pagination.curPageIndex"
          :pager-count="ucSetting.pagination.pagerCount"
          layout="prev, pager"
          :total="ucSetting.pagination.count"
        ></el-pagination>
      </el-footer>

      <div
        v-show="ucSetting.no_POITip"
        class="div_span_noPOI"
      >
        <span class="span_noPOI">该地图级别范围下未查询到相关POI点</span>
      </div>

    </el-container>

  </div>
</template>

<script>
import {
  POIResultItems,
  POISearchFilter
} from "../model/POISearch.js";
import { UCPOISearchEvent } from "./UCPOISearchJs.js";

import { AssetsConfig } from "../../../config/AssetsConfig.js";

export default {
  name: "UCPOIResultPaging",

  props: {},

  data() {
    return {
      ucSetting: {
        pagination: {
          //每页的个数
          pageSize: 10,
          //当前索引
          curPageIndex: 1,
          //显示页数
          pagerCount: 5,
          //总数
          count: -1
        },

        no_POITip: false
      },
      pois: new Array(),

      curFilter: new POISearchFilter()
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      let self = this;

      //初始化
      this.pois = new Array();
      this.ucSetting.pagination.count = 0;
      this.ucSetting.no_POITip = false;

      if (this.curFilter) {
        //默认为第一页
        this._paginationCurrentChange(1);
      }
    },

    //添加监听
    on_searchResultChange(callback) {
      this.$on(UCPOISearchEvent.UCPOIResultPaging_searchResultChange, callback);
    },

    //poi项单击事件
    on_poiItemClick(callback) {
      this.$on(UCPOISearchEvent.UCPOIResultPaging_poiItemClick, callback);
    },

    on_poiItemMouseOver(callback) {
      this.$on(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOver, callback);
    },

    on_poiItemMouseOut(callback) {
      this.$on(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOut, callback);
    },

    //单个poi项单击事件
    _poiItemClick(curPoi) {
      this.$emit(UCPOISearchEvent.UCPOIResultPaging_poiItemClick, curPoi);
    },

    _poiItemMouseOver(curPoi) {
      curPoi.image = curPoi.focusImage;

      this.$emit(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOver, curPoi);
    },

    _poiItemMouseOut(curPoi) {
      curPoi.image = curPoi.ucfocusImage;

      this.$emit(UCPOISearchEvent.UCPOIResultPaging_poiItemMouseOut, curPoi);
    },

    /**
     * 当前页索引改变
     */
    _paginationCurrentChange(pageIndex) {
      let self = this;
      if (pageIndex <= 0 || !this.ucSetting.pagination) return;

      if (!self.curFilter.keyWord) return;

      this.ucSetting.pagination.curPageIndex = pageIndex;

      let startIndex = this.ucSetting.pagination.pageSize * (pageIndex - 1);
      self.curFilter.startIndex = startIndex;
      // self.curFilter.filterType = POISearchFilterType.national_common;

      POIResultItems.search(
        self.curFilter,
        function(searchResult) {
          if (self.pois) {
            self._setImagesForPoi(searchResult.objects);
          }

          self.pois = searchResult.objects;
          self.ucSetting.pagination.count = searchResult.count;
          if (self.ucSetting.pagination.count <= 0) {
            self.ucSetting.no_POITip = true;
          } else {
            self.ucSetting.no_POITip = false;
          }

          //触发改变事件
          self.$emit(
            UCPOISearchEvent.UCPOIResultPaging_searchResultChange,
            self.pois
          );
        },
        function(error) {
          self.ucSetting.no_POITip = true;
        }
      );
    },

    _setImagesForPoi(pois) {
      let tempPoi = null;
      let poiIconIndex = -1;
      for (let tempPoiIndex in pois) {
        poiIconIndex = parseInt(tempPoiIndex) + 1;
        tempPoi = pois[tempPoiIndex];
        //POISearchLayer
        tempPoi.ucfocusImage = AssetsConfig.getPOIIcon(poiIconIndex, true);

        tempPoi.focusImage = AssetsConfig.getPOIIcon(poiIconIndex, false);

        tempPoi.image = tempPoi.ucfocusImage;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.liItem {
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: row;
  line-height: 24px;
  justify-content: flex-start;

  .img_poiDetail
  {
    padding: 10px 0px;
  }

  .div_POIDetail {
    font-size: 12px;
    padding: 10px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .poi_item_name {
      color: #2f87eb;
    }

    .poi_item_info {
      color: #333;
      word-break: break-all;
    }
  }
}

.nav-detail {
  width: 100%;
  padding: 0 17px;
}

.div_span_noPOI {
  text-align: center;
  height: 100%;

  .span_noPOI {
    color: #2f87eb;
    font-size: 16px;
    display: inline-block;
  }
}
.el-footer{
  padding:10px 20px;
}
</style>